<template>
<div class="main">
    <header>{{data.subject}}</header>
    <div class="container">
        <div class="title">
            <h4>
                <div></div> 课程简介
            </h4>
        </div>
        <div class="content">
            {{data.speakerinfo}}
        </div>
        <div class="title">
            <h4>
                <div></div> 课程安排
            </h4>
        </div>
        <div class="content">
            直播时间： {{data.start}} - {{data.liveendDate}}
        </div>
        <div class="title">
            <h4>
                <div></div> 课程老师
            </h4>
        </div>
        <div class="content">
            {{data.teachers}}
        </div>
    </div>
    <div>
        <button @click="join" class="btn">加入课堂</button>
    </div>
</div>
</template>

<script>
// import Gohome from '@/components/gohome/gohome'
import {
    getLiveInfo
} from '@/model/live/serve'
export default {
    name: 'Live',
    data() {
        return {
            data: {
                subject: '标题',
                speakerInfo: "王老师BIM建模讲师",
                scheduleInfo: "xx直播课",
                description: ""
            }
        }
    },
    components: {
        // Gohome
    },
    created() {
        getLiveInfo({
            liveId: this.$route.query.id,
            belong: this.$route.query.sid
        }).then(data => {
            if (data.data.liveNum > 0) {
                this.$router.push(`/livevideo?src=${encodeURIComponent(data.data.studenturl)}`)
                return
            }
            let date = new Date(data.data.livestartDate)
            this.data = data.data
            this.data.start = `${(date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)}-${date.getDay() < 10 ? ('0' + date.getDay()) : date.getDay()} ${date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()}:${date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()}`
        }).catch(data => {
            if (data.retuCode == 5004) {
                this.goLogin()
                // this.$router.push(`/login?pathLogin=live?id%3d${this.$route.query.id}%26sid%3d${this.$route.query.sid}`)
                return
            }
            if (data.retuCode == 5018) {
                this.$router.push(`/liveerror?id=${this.$route.query.id}`)
                return
            }
        })
    },
    methods: {
        goHome() {
            this.$router.push({
                path: '/',
            })
        },
        join() {
            if (this.data.liveNum == 0 || this.data.studenturl == null || this.data.studenturl == '') {
                this.$router.push(`/livelogin?id=${this.$route.query.id}`)
                return
            }
            this.$router.push(`/livevideo?src=${encodeURIComponent(this.data.studenturl)}`)
        }
    },

}
</script>

<style lang="less" scoped>
header {
    padding: 20px;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.15);
    text-align: center;
}

.main {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;
}

.container {
    margin-top: 16px;
    flex: 1;
}

.btn {
    padding: 20px;
    width: 100%;
    background: #f08344;
    outline: none;
    border: none;
    text-decoration: none;
    color: #fff;
    box-shadow: 5px 3px 7px 3px rgba(0, 0, 0, 0.15);
    font-size: 18px;
}

.title {
    padding: 15px;
}

.title h4 div {
    border-left: 4px solid #f08344;
    height: 18px;
    line-height: 18px;
    display: inline-block;
}

.content {
    padding: 0 20px;
    font-size: 15px;
    color: #666;
}
</style>
